// TD Draft 2026-09-29 SLIDER — Bewertungs-Slider in der Kaufbox (snippets/td-slider-reviews.liquid).
// Custom Element, damit der Slider auch nach einem Neu-Rendern der Kaufbox (Produktwechsel, Theme-Editor)
// wieder funktioniert — das frühere Inline-Script lief dann nicht erneut.
// Verhalten wie bisher (FB 28.09.): Endlosschleife (links vom ersten → letzter, rechts vom letzten → erster),
// Wischen ab 40px; neu: Punkte zeigen/wechseln die Position, Pfeiltasten, inaktive Karten für Screenreader aus.
// "Bewegung reduzieren" wird im CSS berücksichtigt (keine Gleit-Animation).
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('td-reviews-slider')) return;

  var SWIPE_MIN = 40;

  class TdReviewsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.td-rs__track');
      this.cards = this.track ? Array.prototype.slice.call(this.track.children) : [];
      if (this.cards.length < 2) return;

      this.dots = Array.prototype.slice.call(this.querySelectorAll('.td-rs__dots > button'));
      this.index = 0;
      this.abortController = new AbortController();

      var signal = this.abortController.signal;
      var self = this;
      var prev = this.querySelector('[data-td-rs-prev]');
      var next = this.querySelector('[data-td-rs-next]');
      var viewport = this.querySelector('.td-rs__viewport') || this.track;

      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); }, { signal: signal });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); }, { signal: signal });

      this.dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { self.go(i); }, { signal: signal });
      });

      // Pfeiltasten, solange der Fokus auf Pfeil oder Punkt liegt
      this.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (!event.target.closest || !event.target.closest('.td-rs__controls')) return;
        event.preventDefault();
        var step = (event.key === 'ArrowRight' ? 1 : -1) * self.direction();
        self.go(self.index + step);
        if (self.dots.indexOf(event.target) > -1 && self.dots[self.index]) self.dots[self.index].focus();
      }, { signal: signal });

      // Wischen: nur waagerechte Gesten, senkrechtes Scrollen bleibt unberührt
      var startX = null;
      var startY = 0;
      viewport.addEventListener('touchstart', function (event) {
        var touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
      }, { passive: true, signal: signal });
      viewport.addEventListener('touchend', function (event) {
        if (startX === null) return;
        var touch = event.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        startX = null;
        if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) <= Math.abs(dy)) return;
        self.go(self.index + (dx < 0 ? 1 : -1) * self.direction());
      }, { passive: true, signal: signal });
      viewport.addEventListener('touchcancel', function () { startX = null; }, { passive: true, signal: signal });

      // Theme-Editor: ausgewählte Bewertung anzeigen
      document.addEventListener('shopify:block:select', function (event) {
        var i = self.cards.indexOf(event.target);
        if (i > -1) self.go(i);
      }, { signal: signal });

      this.render();
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
    }

    direction() {
      return window.getComputedStyle(this).direction === 'rtl' ? -1 : 1;
    }

    go(i) {
      var count = this.cards.length;
      this.index = ((i % count) + count) % count;
      this.render();
    }

    render() {
      var current = this.index;
      this.track.style.transform = current ? 'translateX(' + (-100 * current * this.direction()) + '%)' : '';
      this.cards.forEach(function (card, i) {
        if (i === current) {
          card.removeAttribute('aria-hidden');
        } else {
          card.setAttribute('aria-hidden', 'true');
        }
      });
      this.dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }
  }

  window.customElements.define('td-reviews-slider', TdReviewsSlider);
})();
